import React, { useEffect, useState } from 'react';

// MUI
import { styled } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

const StyledFormControl = styled(FormControl)(({ disabled }) => ({
  width: '100%',
  ...(disabled && {
    '& .MuiFormControlLabel-label': {
      color: 'rgba(0, 0, 0, 0.6)',
    },
  }),
}));

const StyledCheckbox = styled(Checkbox)({
  padding: '4px 9px',
});

function CheckboxInput({ data }) {
  const {
    answers,
    column,
    rowIndex,
    columnIndex,
    updateValue,
    isReadOnly,
    isRS,
  } = data;
  const [selectedValues, setSelectedValues] = useState([]);

  // Parse stored value (comma-separated string) to array
  const parseStoredValue = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    return value.split(',').filter((v) => v.trim() !== '');
  };

  useEffect(() => {
    const currentValue = answers[rowIndex][columnIndex].calculatedValue;
    const parsed = parseStoredValue(currentValue);
    setSelectedValues(parsed);
  }, [answers, rowIndex, columnIndex]);

  // For deleting a row in repeatable sections
  useEffect(() => {
    if (isRS) {
      const currentValue = answers[rowIndex][columnIndex].calculatedValue;
      const parsed = parseStoredValue(currentValue);
      if (JSON.stringify(parsed) !== JSON.stringify(selectedValues)) {
        setSelectedValues(parsed);
      }
    }
  }, [answers]);

  const handleChange = (optionValue, checked) => {
    let newValues;
    if (checked) {
      newValues = [...selectedValues, optionValue];
    } else {
      newValues = selectedValues.filter((v) => v !== optionValue);
    }
    setSelectedValues(newValues);
    // Store as comma-separated string
    updateValue(rowIndex, columnIndex, newValues.join(','), false);
  };

  return (
    <StyledFormControl disabled={isReadOnly}>
      <FormGroup id={`table-row-${rowIndex}-col-${columnIndex}`}>
        {column.options &&
          column.options.map((opt) => (
            <FormControlLabel
              key={opt.id}
              control={
                <StyledCheckbox
                  size="small"
                  checked={selectedValues.includes(opt.value)}
                  onChange={(e) => handleChange(opt.value, e.target.checked)}
                />
              }
              label={opt.label || opt.value}
            />
          ))}
      </FormGroup>
    </StyledFormControl>
  );
}

export default CheckboxInput;
